import DownloadSmartGroupDetails from './download-smartgroup-details';
export default DownloadSmartGroupDetails;
